/**
 * Gerador de Código de Barras Code 128 (Conjunto B) em SVG
 * Leve, sem dependências externas, compatível com qualquer navegador e leitor laser USB.
 */

// Padrões de barras do Code 128 (larguras dos traços e espaços)
const CODE128_PATTERNS = [
  "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
  "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
  "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
  "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
  "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
  "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
  "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
  "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
  "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
  "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
  "114131", "311141", "411131", "211412", "211214", "211232", "2331112"
];

const START_CODE_B = 104;
const STOP_CODE = 106;

/**
 * Converte uma string alfanumérica em SVG com código de barras Code 128
 * @param {string} text - Texto a ser codificado
 * @param {object} options - Opções de visualização (height, barWidth, showText)
 * @returns {string} Código SVG renderizável
 */
export const generateCode128Svg = (text, options = {}) => {
  if (!text) return '';
  const cleanText = String(text).trim();
  const height = options.height || 40;
  const barWidth = options.barWidth || 1.4;
  const showText = options.showText !== false;

  // Code 128B mapeia ASCII 32 a 126 subtraindo 32
  const codes = [START_CODE_B];
  let checkSum = START_CODE_B;

  for (let i = 0; i < cleanText.length; i++) {
    const charCode = cleanText.charCodeAt(i);
    const value = charCode - 32;
    if (value >= 0 && value <= 95) {
      codes.push(value);
      checkSum += value * (i + 1);
    }
  }

  const checkDigit = checkSum % 103;
  codes.push(checkDigit);
  codes.push(STOP_CODE);

  // Gerar sequência de módulos de barras
  let modules = '';
  for (const code of codes) {
    const pattern = CODE128_PATTERNS[code] || '';
    let isBar = true;
    for (let j = 0; j < pattern.length; j++) {
      const width = parseInt(pattern[j], 10);
      modules += (isBar ? '1' : '0').repeat(width);
      isBar = !isBar;
    }
  }

  // Desenhar barras SVG
  const quietZone = 10;
  const totalModules = modules.length;
  const totalWidth = (totalModules * barWidth) + (quietZone * 2);
  const totalHeight = showText ? height + 14 : height;

  let rects = '';
  let x = quietZone;

  for (let i = 0; i < modules.length; i++) {
    if (modules[i] === '1') {
      rects += `<rect x="${x.toFixed(2)}" y="0" width="${barWidth.toFixed(2)}" height="${height}" fill="#000" />`;
    }
    x += barWidth;
  }

  const textElement = showText
    ? `<text x="${(totalWidth / 2).toFixed(2)}" y="${(height + 11).toFixed(2)}" text-anchor="middle" font-family="monospace" font-size="9" font-weight="bold" fill="#000">${cleanText}</text>`
    : '';

  return `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${totalWidth} ${totalHeight}" width="100%" height="${totalHeight}px" preserveAspectRatio="xMidYMid meet">
      ${rects}
      ${textElement}
    </svg>
  `.trim();
};
